/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useCallback,
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react";
import "./upcoming-auction.styles.scss";

import dayjs from "dayjs";
import { ReactComponent as CloseIcon } from "../../assets/cancel.svg";
import { ReactComponent as CheckedIcon } from "../../assets/checked.svg";

import { DeleteOutlined, EditOutlined, SyncOutlined } from "@ant-design/icons";

import { connect, useDispatch } from "react-redux";

// import { getCompanyParams } from "../../services/sys-params-services";
// import {
//   getSysParams,
//   getCompanyParams,
// } from "../../services/sys-params-services";

import { createStructuredSelector } from "reselect";

import {
  selectBagtypeList,
  selectBranches,
  selectCrops,
  selectCurrentPage,
  selectDefaultParams,
  selectDivisionList,
  selectFreezingTime,
  selectMinQty,
  selectRebates,
  selectSelectedCrop,
  selectVarieties,
  selectViewAuctionPage,
} from "../../redux/common/common.selectors";

import { ExclamationCircleOutlined } from "@ant-design/icons";

import {
  //   getUpcomingAuction,
  cancelAuction,
  editAuction,
} from "../../services/auction-services";
import {
  getRebateMatrixService,
  getRebateService,
  // getRebateService,
} from "../../services/common-services";

import { FeatureCodes } from "../../constants/data-constants";
import { canUserAccess } from "../../utils/utils";

import {
  Table,
  message,
  Modal,
  Button,
  Select,
  Input,
  Checkbox,
  Flex,
  Space,
} from "antd";

import CustomFilter from "../../components/custom-filter/custom-filter.component";
import {
  selectAuthData,
  selectUserData,
} from "../../redux/user/user.selectors";
import { TableProps } from "antd/lib";
import { setSelectedCrop } from "../../redux/common/common.actions";
import { useLocation } from "react-router";
// import { setBranchIndex } from "../../redux/common/common.actions";
// import { Dispatch } from "redux";

const { confirm } = Modal;
const { Option } = Select;
const { Search } = Input;
const editDefault = {
  qty_rqd: undefined,
  rebate_matrix_id: undefined,
  auction_id: undefined,
  bagType: undefined,
  maxPrice: undefined,
  division: undefined,
  variety: undefined,
};

const UpcomingAuction: React.FC = (props: any) => {
  const {
    branches,
    selectedCropId,
    user,
    globalSocketData,
    crops,
    currentpage,
    viewAuctionPage,
    selectedBranch,
    setBranch,
    // auth,
    parametersData,
    freezingTime,
    rebates,
    minQuantity,
    divisions,
    bagType,
    varieties,
  } = props;
  const dispatch = useDispatch();
  const [upcomingData, setUpcomingData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedData, setSelectedData] = useState<any[]>([]);
  // const [rebates, setRebates] = useState<any>();
  const [valueToEdit, setValueToEdit] = useState<any>(editDefault);
  const [rebateModalVisible, setRebateModalVisible] = useState(false);
  const [rebateTableData, setRebateTableData] = useState<Array<any>>();
  // const [localCropID, setLocalCropID] = useState<any>();
  // const [minQuantity, setMinQuantity] = useState<any>([]);
  const [error, setError] = useState<String>("");
  const [rebateList, setRebateList] = useState<any>([]);
  const [searchText, setSearchText] = useState("");
  const location = useLocation();
  let upcomingAuctionsIntervalID = useRef<NodeJS.Timeout>();
  const TableColumnHeader = (props: any) => {
    const { title, subtitle } = props;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            fontWeight: 400,
            color: "white",
            fontSize: "12px",
            textAlign: "left",
            marginLeft: "0px",
            justifyContent: "flex-start",
            float: "left",
          }}
        >
          {title}
        </div>
        <div
          style={{
            color: "#cbdfff",
            fontSize: "8px",
            fontWeight: "normal",
            textAlign: "left",
          }}
        >
          {subtitle}
        </div>
      </div>
    );
  };
  const columns = [
    {
      title: "ID",
      sorter: (a, b) => a.id - b.id,
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Hub",
      sorter: (a, b) => a.hub.localeCompare(b.hub),
      dataIndex: "hub",
      key: "hub",
    },
    {
      title: "Division",
      sorter: (a, b) => a.division - b.division,
      dataIndex: "division",
      key: "division",
      render: (value: number) => {
        return <div>{value === 1 ? "ABD" : value === 2 ? "FBD" : "NCDEX"}</div>;
      },
      width: 90,
      // align: "center",
    },
    {
      title: "Claim",
      dataIndex: "claim",
      key: "claim",
      render: (value: number) => {
        return (
          <div className="claim-container">
            {value === 1 ? <CheckedIcon /> : <CloseIcon />}
          </div>
        );
      },
    },
    {
      title: "Variety",
      sorter: (a, b) => a.variety.localeCompare(b.variety),
      dataIndex: "variety",
      key: "variety",
    },
    {
      title: `Qty Reqd (${
        crops?.find((item) => item.id == selectedCropId)?.unit
      })`,
      dataIndex: "qtyReqd",
      key: "qtyReqd",
    },
    {
      title: `Max Price (₹/${
        crops?.find((item) => item.id == selectedCropId)?.unit
      })`,
      dataIndex: "maxPrice",
      key: "maxPrice",
    },

    {
      title: "Sauda Type",
      dataIndex: "saudhaType",
      key: "saudhaType",
      render: (value: number) => {
        return <div>{value === 1 ? "Net basis" : "Gross basis"}</div>;
      },
    },
    {
      title: "Role",
      dataIndex: "roleType",
      key: "Role",
      render: (value: number) => {
        return (
          <div>
            {value === 1
              ? "Broker/Trader"
              : value === 2
              ? "FPO"
              : value === 3
              ? "Broker/Trader & FPO"
              : "Not Selected"}
          </div>
        );
      },
    },
    {
      title: "Start Time",
      dataIndex: "startTime",
      key: "startTime",
      render: (value: string) => {
        return <div>{dayjs(value, "HH:mm:ss").format("hh:mm A")}</div>;
      },
    },
    {
      title: "End Time",
      dataIndex: "endTime",
      key: "endtime",
      render: (value: string) => {
        return <div>{dayjs(value, "HH:mm:ss").format("hh:mm A")}</div>;
      },
    },
    {
      title: "Rake Sauda",
      dataIndex: "auction_type",
      key: "auction_type",
      render: (value: any) => {
        return <div>{value == 2 || value == 3 ? "Y" : "N"}</div>;
      },
    },
    {
      title: "Rebate Name",
      dataIndex: "rebateName",
      key: "rebateName",
      render: (value: number, row: any) => {
        return (
          <div className={"rebate-info-upcoming"}>
            {value}
            {value && (
              <span
                className="info"
                onClick={() => {
                  getRebateMatrix(row.rebateId, selectedBranch);
                }}
              >
                ?
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (value: boolean, rowData: any) => {
        return (
          <>
            <span
              className={`edit-container ${
                (!canUserAccess(user, FeatureCodes.AUCTION_CHECKER) ||
                  canUserAccess(user, FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS)) &&
                "disabled"
              }`}
              style={{ paddingInline: "0 10px" }}
              onClick={() => onEditClicked(rowData)}
            >
              <EditOutlined />
            </span>
            <span
              className={`cancel-container ${
                (!canUserAccess(user, FeatureCodes.AUCTION_CHECKER) ||
                  canUserAccess(user, FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS)) &&
                "disabled"
              }`}
              style={{ paddingInline: "10px 0" }}
              onClick={() => showPromiseConfirm(rowData.key)}
            >
              <DeleteOutlined />
            </span>
          </>
        );
      },
    },
    // {
    //   title: "",
    //   dataIndex: "edit",
    //   key: "edit",
    //   render: (value: boolean, rowData: any) => {
    //     return (
    //       <div
    //         className={`edit-container ${
    //           !canUserAccess(user, FeatureCodes.AUCTION_CHECKER) && "disabled"
    //         }`}
    //         onClick={() => onEditClicked(rowData)}
    //       >
    //         Edit
    //       </div>
    //     );
    //   },
    // },
    // {
    //   title: (
    //     <div
    //       style={{
    //         fontSize: "8px",
    //         color: "white",
    //         display: "flex",
    //         flexDirection: "row",
    //         justifyContent: "space-between",
    //         width: "100%",
    //         paddingRight: "13px",
    //         marginRight: "10px",
    //       }}
    //     >
    //       {(!canUserAccess(user, FeatureCodes.AUCTION_APPROVE_VIEW) ||
    //         canUserAccess(user, FeatureCodes.AUCTION_CHECKER)) && (
    //         <>
    //           {/* <TableColumnHeader
    //             title="Select All"
    //             style={{ marginLeft: "0px" }}
    //           /> */}
    //           <div
    //             style={{
    //               display: "flex",
    //             }}
    //           >
    //             <Checkbox
    //               style={{ margin: "auto" }}
    //               checked={
    //                 upcomingData &&
    //                 upcomingData.length !== 0 &&
    //                 (upcomingData && upcomingData.length) ===
    //                   (selectedData && selectedData.length)
    //               }
    //               disabled={
    //                 canUserAccess(user, FeatureCodes.AUCTION_CHECKER)
    //                   ? false
    //                   : true
    //               }
    //               onChange={(e) => {
    //                 let count = 0;
    //                 const modifiedData =
    //                   upcomingData && upcomingData.length
    //                     ? upcomingData.map((item: any) => {
    //                         if (
    //                           dayjs(
    //                             dayjs(new Date(), "HH:mm:ss").add(
    //                               freezingTime,
    //                               "minutes"
    //                             ),
    //                             "HH:mm:ss"
    //                           ).isBefore(dayjs(item.startTime, "HH:mm:ss"))
    //                         ) {
    //                           return item.id;
    //                         }
    //                       })
    //                     : [];
    //                 if (e.target.checked === true) {
    //                   setSelectedData(modifiedData);
    //                 } else {
    //                   setSelectedData([]);
    //                 }
    //               }}
    //             />
    //           </div>
    //         </>
    //       )}
    //     </div>
    //   ),
    //   key: "action",
    //   dataIndex: "action",
    //   render: (value: number, row: any) => {
    //     return (
    //       <div className="approval-table-checkbox">
    //         {(!canUserAccess(user, FeatureCodes.AUCTION_APPROVE_VIEW) ||
    //           canUserAccess(user, FeatureCodes.AUCTION_CHECKER)) && (
    //           <Checkbox
    //             checked={
    //               Array.isArray(selectedData) && selectedData.includes(row.id)
    //             }
    //             disabled={
    //               canUserAccess(user, FeatureCodes.AUCTION_CHECKER)
    //                 ? false
    //                 : true
    //             }
    //             onChange={(e) => {
    //               if (
    //                 dayjs(
    //                   dayjs(new Date(), "HH:mm:ss").add(
    //                     freezingTime,
    //                     "minutes"
    //                   ),
    //                   "HH:mm:ss"
    //                 ).isAfter(dayjs(row.startTime, "HH:mm:ss"))
    //               ) {
    //                 message.error(
    //                   "Cannot approve the auction during freezing period"
    //                 );
    //               } else {
    //                 if (e.target.checked === true) {
    //                   setSelectedData([...selectedData, row.id]);
    //                 } else {
    //                   const temp = selectedData.filter(
    //                     (item) => item !== row.id
    //                   );
    //                   setSelectedData(temp);
    //                 }
    //               }
    //             }}
    //           />
    //         )}
    //       </div>
    //     );
    //   },
    // },
  ];
  const filteredData = useMemo(() => {
    if (!searchText) return upcomingData;

    return upcomingData.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [upcomingData, searchText]);
  useEffect(() => {
    // if (currentpage == "3" && viewAuctionPage === 31" && globalSocketData) {
    if (
      location.pathname.includes("/TN/viewauction/upcoming") &&
      globalSocketData
    ) {
      upcomingAuctionsIntervalID.current &&
        clearInterval(upcomingAuctionsIntervalID.current);
      upcomingAuctionsDataSocketEmition();
      upcomingAuctionsIntervalID.current = setInterval(() => {
        upcomingAuctionsDataSocketEmition();
      }, 10000);
    }
    return () => {
      upcomingAuctionsIntervalID.current &&
        clearInterval(upcomingAuctionsIntervalID.current);
    };
  }, [
    currentpage,
    viewAuctionPage,
    globalSocketData,
    selectedBranch,
    selectedCropId,
  ]);

  /**
   *
   * @function
   * @description Establish socket.io connection for getting auction cards data.
   * @memberof App.MainLayout
   */
  const upcomingAuctionsDataSocketEmition = () => {
    if (globalSocketData) {
      globalSocketData.emit("tm_upcoming_auction_event", {
        crop_id: selectedCropId,
        branch_id: selectedBranch,
        approval_status: 1,
      });
      globalSocketData.on("tm_upcoming_auctions", (data: any) => {
        const modifiedData = data.map((item: any) => {
          return {
            key: item.auction_id,
            id: item.auction_id,
            hub: item.hub_name,
            division: item.division,
            claim: item.claim_type,
            variety: item.variety_name,
            qtyReqd: item.qty_rqd,
            maxPrice: item.max_price,
            saudhaType: item.saudha_type,
            roleType: item.role_mapping,
            rebateName: item.rebate_name,
            startTime: item.start_time,
            endTime: item.end_time,
            rebateId: item.rebate_id,
            bagType: item.bag_type,
            minPrice: item.min_price,
            auction_type: item.auction_type,
          };
        });
        setUpcomingData(modifiedData);
        setIsLoading(false);
      });
    }
  };

  const onEditClicked = async (data: any) => {
    // getParamsMinQty({ branch_id: selectedBranch, crop_id: selectedCropId });
    if (
      dayjs(
        dayjs(new Date(), "HH:mm:ss").add(freezingTime, "minutes"),
        "HH:mm:ss"
      ).isAfter(dayjs(data.startTime, "HH:mm:ss"))
    ) {
      message.error("cannot edit the auction during freezing period");
    } else {
      setValueToEdit({
        qty_rqd: data.qtyReqd,
        rebate_matrix_id: data.rebateId,
        auction_id: data.id,
        claim: data.claim,
        maxPrice: data.maxPrice,
        division: data.division,
        bagType: data.bagType,
        variety: data.variety,
        auction_type: data.auction_type,
      });
      const rebateParams = {
        crop_id: selectedCropId,
        branch_id: selectedBranch,
        variety_id: varieties.filter(
          (item: any) => item.name === data.variety
        )[0].id,
        division: divisions.filter((item: any) => item.id === data.division)[0]
          .name,
      };
      getVarietyData(rebateParams);
      setIsEdit(true);
    }
  };
  const getVarietyData = async (params: any) => {
    try {
      const rebateListResponse = await getRebateService(params);
      if (rebateListResponse.data.status) {
        setRebateList(rebateListResponse.data.data);
      }
    } catch (error) {
      console.warn("error", error);
    }
  };

  const cancelAuctionFn = async (auctionId: number) => {
    const dataToSend = {
      auction_id_list: [auctionId],
    };
    try {
      const response = await cancelAuction(dataToSend);
      if (response.data.status) {
        message.success("Auction cancelled successfully...!");
        upcomingAuctionsDataSocketEmition();
      } else message.warning("Cannot cancel auction...!");
    } catch (error) {
      console.log(error);
    }
  };

  function showPromiseConfirm(auctionId: number) {
    confirm({
      title: "Cancel Auction",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you want to cancel the auction ?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        cancelAuctionFn(auctionId);
      },
      onCancel() {},
    });
  }

  const onCancelClick = async (dataToPut: any) => {
    setIsLoading(true);
    dataToPut = dataToPut
      .map((element: any) => {
        if (selectedData.includes(element.id)) return element;
        else return undefined;
      })
      .filter((item: any) => item !== undefined);

    const list = dataToPut.map((eachRow: any) => {
      return eachRow.id;
    });
    if (list !== undefined && list !== null && list !== "" && list.length > 0) {
      const reqBody = {
        auction_id_list: list,
      };
      try {
        const response = await cancelAuction(reqBody);
        if (response.data.status) {
          message.success("Auction cancelled successfully...!");
          setSelectedData([]);
          upcomingAuctionsDataSocketEmition();
        } else {
          message.warning("Cannot cancel auction...!");
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      message.error("Select atleast one row.", 2);
    }
    setIsLoading(false);
  };

  const getRebateMatrix = async (
    rebateId: string,
    branchId: number | undefined
  ) => {
    const params = {
      rebate_id: rebateId,
      branch_id: branchId,
      crop_id: selectedCropId,
    };
    try {
      const response = await getRebateMatrixService(params);
      if (response.data.status) {
        setRebateModalVisible(true);
        setRebateTableData(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const rebateColumns = [
    {
      title: "Head",
      dataIndex: "head",
      key: "head",
      render(_: any, row: any) {
        return {
          children: row.head,
          props: {
            rowSpan: row.rowSpan,
          },
        };
      },
    },
    {
      title: "Slab",
      dataIndex: "slab",
      key: "slab",
    },
    {
      title: "Rebate",
      dataIndex: "rate_display",
      key: "rate_display",
    },
  ];
  const createNewArr = (data: any) => {
    if (data)
      return data
        .reduce((result: any, item: any) => {
          //First, take the name field as a new array result
          if (result.indexOf(item.head) < 0) {
            result.push(item.head);
          }
          return result;
        }, [])
        .reduce((result: any, head: any) => {
          //Take the data with the same name as a new array, and add a new field * * rowSpan inside it**
          const children = data.filter((item: any) => item.head === head);
          result = result.concat(
            children.map((item: any, index: any) => ({
              ...item,
              rowSpan: index === 0 ? children.length : 0, //Add the first row of data to the rowSpan field
            }))
          );
          return result;
        }, []);
  };

  const updateAuction = async () => {
    try {
      let matrix_id = {};
      if (valueToEdit.rebate_matrix_id) {
        matrix_id = { rebate_matrix_id: valueToEdit.rebate_matrix_id };
      }
      const maxPrice = varieties.filter(
        (item: any) => item.name === valueToEdit.variety
      )[0].maxPrice;
      const minPrice = varieties.filter(
        (item: any) => item.name === valueToEdit.variety
      )[0].minPrice;
      if (
        Number(valueToEdit.maxPrice) <= minPrice ||
        Number(valueToEdit.maxPrice) >= maxPrice
      ) {
        message.warning(
          `Max price should be between the range ${minPrice} (₹/${
            crops?.find((item) => item.id == selectedCropId)?.unit
          }) to ${maxPrice} (₹/${
            crops?.find((item) => item.id == selectedCropId)?.unit
          })...`
        );
        return false;
      }
      const param = {
        qty_rqd:
          valueToEdit.qty_rqd !== null ||
          valueToEdit.qty_rqd !== undefined ||
          valueToEdit.qty_rqd !== ""
            ? Number(valueToEdit.qty_rqd)
            : 0,
        ...matrix_id,
        auction_id: valueToEdit.auction_id,
        max_price: Number(valueToEdit.maxPrice),
        bag_type: valueToEdit.bagType,
        division: valueToEdit.division,
      };
      const response = await editAuction(param);
      if (response.data.status) {
        message.success("Updated auction successfully..!");

        upcomingAuctionsDataSocketEmition();
        setIsEdit(false);
        setError("");
      } else message.error("Could not update auction..!");
    } catch (error: any) {
      console.log(error);
      message.error(
        error.response.data.message || "Could not update auction..!"
      );
    }
  };
  const rowSelection: TableProps<any>["rowSelection"] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      if (selectedRowKeys) {
        setSelectedData(selectedRowKeys);
      } else {
        setSelectedData([]);
      }
    },
    getCheckboxProps: (record: any) => ({
      disabled:
        !canUserAccess(user, FeatureCodes.AUCTION_CHECKER) ||
        dayjs(
          dayjs(new Date(), "HH:mm:ss").add(freezingTime, "minutes"),
          "HH:mm:ss"
        ).isBefore(dayjs(record.startTime, "HH:mm:ss")), // Column configuration not to be checked
      id: record.id,
    }),
  };
  return (
    <div className="upcoming-auction">
      <Modal
        className="edit-modal"
        open={isEdit}
        onCancel={() => {
          setIsEdit(false);
          setValueToEdit(editDefault);
          setError("");
        }}
        footer={false}
        maskClosable={false}
      >
        <div className="header">Edit Auction</div>
        <div className="form-container">
          <div className={`form-items`}>
            <div className="label">
              Quantity ({crops?.find((item) => item.id == selectedCropId)?.unit}
              )
            </div>
            {valueToEdit.auction_type == 3 ? (
              <Select
                placeholder="Slot Qty"
                value={valueToEdit.qty_rqd}
                onChange={(e) => {
                  setValueToEdit((prevState: any) => ({
                    ...prevState,
                    qty_rqd: e,
                  }));
                }}
                options={[
                  {
                    value: Number(parametersData?.rj_container_bid_full_rake),
                    label: parametersData?.rj_container_bid_full_rake,
                  },
                  {
                    value: Number(parametersData?.rj_container_bid_half_rake),
                    label: parametersData?.rj_container_bid_half_rake,
                  },
                ]}
              />
            ) : (
              <Input
                value={valueToEdit.qty_rqd}
                type="number"
                placeholder="Slot Qty"
                onChange={(e) => {
                  setValueToEdit((prevState: any) => ({
                    ...prevState,
                    qty_rqd: e.target.value,
                  }));
                }}
                onBlur={(e: any) => {
                  if (
                    valueToEdit.auction_type == 2 &&
                    !/^\d+(\.5)?$/.test(
                      `${e.target.value / parametersData.full_rake}`
                    )
                  ) {
                    message.warning("Enter Valid Quantity...!");
                    setValueToEdit((prevState: any) => ({
                      ...prevState,
                      qty_rqd: "",
                    }));
                  }
                }}
              />
            )}
            {error && (
              <p style={{ color: "red" }} className="label">
                {error}
              </p>
            )}
          </div>

          {valueToEdit.claim === 1 && (
            <div className={`form-items`}>
              <div className="label help">
                Rebate Name
                <div
                  className="info"
                  onClick={() => {
                    getRebateMatrix(
                      valueToEdit.rebate_matrix_id,
                      selectedBranch
                    );
                  }}
                >
                  ?
                </div>
              </div>

              <Select
                placeholder="Rebate Name"
                value={valueToEdit.rebate_matrix_id}
                showSearch
                filterOption={(inputValue, option: any) =>
                  option.children
                    .toLowerCase()
                    .indexOf(inputValue.toLowerCase()) >= 0
                }
                onChange={(value) =>
                  setValueToEdit((prevState: any) => ({
                    ...prevState,
                    rebate_matrix_id: value,
                  }))
                }
              >
                {rebateList &&
                  rebateList.map((item: any) => (
                    <Option
                      value={item.rebate_id}
                      id={item.rebate_id}
                      key={item.rebate_id}
                    >
                      {item.rebate_name}
                    </Option>
                  ))}
              </Select>
            </div>
          )}
          <div className={`form-items`}>
            <div className="label">
              Max Price (₹/
              {crops?.find((item) => item.id == selectedCropId)?.unit})
            </div>
            <Input
              value={valueToEdit.maxPrice}
              type="number"
              placeholder="Max Price"
              onChange={(e) => {
                setValueToEdit((prevState: any) => ({
                  ...prevState,
                  maxPrice: e.target.value,
                }));
              }}
            />
          </div>
          <div className={`form-items`}>
            <div className="label help">Division</div>
            <Select
              placeholder="Variety"
              showSearch
              filterOption={(inputValue, option: any) =>
                option.children
                  .toLowerCase()
                  .indexOf(inputValue.toLowerCase()) >= 0
              }
              value={valueToEdit.division}
              onChange={(value) =>
                setValueToEdit((prevState: any) => ({
                  ...prevState,
                  division: value,
                }))
              }
            >
              {divisions &&
                divisions.map((item: any) => (
                  <Option value={item.id} id={item.id} key={item.id}>
                    {item.name}
                  </Option>
                ))}
            </Select>
          </div>
          <div className={`form-items`}>
            <div className="label help">Bag Type</div>
            <Select
              placeholder="Bag Type"
              showSearch
              filterOption={(inputValue, option: any) =>
                option.children
                  .toLowerCase()
                  .indexOf(inputValue.toLowerCase()) >= 0
              }
              value={valueToEdit.bagType}
              onChange={(value) =>
                setValueToEdit((prevState: any) => ({
                  ...prevState,
                  bagType: value,
                }))
              }
            >
              {bagType &&
                bagType.map((item: any) => (
                  <Option value={item.id} id={item.id} key={item.id}>
                    {item.name}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
        <div className="update-btn-container">
          <Button onClick={updateAuction}>Update</Button>
        </div>
      </Modal>

      <Modal
        className="rebate-modal"
        open={rebateModalVisible}
        onCancel={() => setRebateModalVisible(false)}
        footer={false}
        zIndex={1001}
      >
        <div className="rebate-header">Rebate Matrix</div>
        <div className="rebate-container">
          <Table
            columns={rebateColumns}
            dataSource={createNewArr(rebateTableData)}
            pagination={false}
            scroll={{ y: window.innerHeight - 165 }}
            size="small"
          />
        </div>
      </Modal>
      <div className="label noteText">
        <b>
          {parametersData !== undefined && parametersData !== null
            ? ` NOTE: Auction cannot be Edited or Approved ${parametersData.auction_freeze_period} minute(s) before the start time.`
            : ""}
        </b>
      </div>
      <Flex justify="space-between">
        <Space wrap>
          <Search
            placeholder="Search..."
            allowClear
            onSearch={setSearchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: "15em" }}
            variant="outlined"
          />
          <CustomFilter
            type="single-select"
            value={selectedBranch}
            options={branches}
            onChange={(value: any) => setBranch(value)}
            head="ITC Branch Office"
            returnId
          />
          <CustomFilter
            type="single-select"
            value={selectedCropId}
            options={crops}
            onChange={(value: any) => {
              dispatch(setSelectedCrop(value));
            }}
            head="Crops"
            returnId
          />
        </Space>
        {/* <div className="selected-wheat">
          <span className="selected-wheat-label">Selected Crop</span> <br />
          <span className="selected-wheat-value">
            <b>
              {crops &&
                crops.length &&
                crops.find(
                  (item: { id: number; name: string }) =>
                    item.id == selectedCropId
                ).name}
            </b>
          </span>
        </div> */}
        <Button
          className="refreshButton"
          icon={<SyncOutlined spin={isLoading} />}
          onClick={() => upcomingAuctionsDataSocketEmition()}
        >
          Refresh
        </Button>
      </Flex>
      <div className="upcoming-table-container" style={{ paddingTop: 10 }}>
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={filteredData}
          // dataSource={upcomingData}
          pagination={false}
          rowSelection={{ type: "checkbox", ...rowSelection }}
          size="small"
          tableLayout="auto"
          // scroll={{ x: window.innerWidth }}
          footer={() =>
            upcomingData.length > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                {(!canUserAccess(user, FeatureCodes.AUCTION_APPROVE_VIEW) ||
                  canUserAccess(user, FeatureCodes.AUCTION_CHECKER)) && (
                  <Button
                    className={
                      canUserAccess(user, FeatureCodes.AUCTION_CHECKER)
                        ? "cancel-btn"
                        : "cancel-btn disabled"
                    }
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                      confirm({
                        title: "Cancel Auction",
                        icon: <ExclamationCircleOutlined />,
                        content:
                          "Are you sure you want to cancel the selected auction ?",
                        okText: "Yes",
                        cancelText: "No",
                        onOk() {
                          onCancelClick(upcomingData);
                        },
                        onCancel() {},
                      });
                    }}
                    loading={isLoading}
                    disabled={canUserAccess(
                      user,
                      FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
                    )}
                  >
                    Cancel
                  </Button>
                )}
              </div>
            )
          }
          // scroll={{ y: window.innerHeight - 265 }}
        />
      </div>
    </div>
  );
};
const mapStateToProps = createStructuredSelector({
  branches: selectBranches,
  crops: selectCrops,
  selectedCropId: selectSelectedCrop,
  user: selectUserData,
  auth: selectAuthData,
  currentpage: selectCurrentPage,
  viewAuctionPage: selectViewAuctionPage,
  parametersData: selectDefaultParams,
  freezingTime: selectFreezingTime,
  minQuantity: selectMinQty,
  rebates: selectRebates,
  bagType: selectBagtypeList,
  divisions: selectDivisionList,
  varieties: selectVarieties,
});

export default connect(mapStateToProps)(UpcomingAuction);
